import { createMemoryHistory, createRouter } from 'vue-router';

import MainView from '@/views/MainView.vue';
import SignPage from '@/views/SignPage.vue';
import InfoView from '@/views/InfoView.vue';

import RequestContent from '@/components/RequestContent.vue';
import ApprovalContent from '@/components/ApprovalContent.vue';
import FinanceContent from '@/components/FinanceContent.vue';
import UserContent from '@/components/UserContent.vue';
import GeneralContent from '@/components/GeneralContent.vue';

import { NAVBAR_OPTIONS } from "@/helpers/constants/app.constants";

const router = createRouter({
  history: createMemoryHistory(),

  routes: [
    {
      path: '/',
      name: 'MainView',
      component: MainView,
      children: [
        //   NOTE: Saving this child for pattern reference.
        {
          name: NAVBAR_OPTIONS.REQUEST_VIEW.name,
          path: '/request',
          component: RequestContent
        },
        {
          name: NAVBAR_OPTIONS.APPROVAL_VIEW.name,
          path: '/approval',
          component: ApprovalContent
        },
        {
          name: NAVBAR_OPTIONS.FINANCE_VIEW.name,
          path: '/finance',
          component: FinanceContent
        },
        {
          name: NAVBAR_OPTIONS.USER_VIEW.name,
          path: '/user',
          component: UserContent
        },
        {
          name: NAVBAR_OPTIONS.GENERAL_VIEW.name,
          path: '/general',
          component: GeneralContent
        },
      ]
    },
    {
      path: '/login',
      name: 'SignPage',
      component: SignPage,
    },
    {
      path: '/awaiting-approval',
      name: 'InfoView',
      component: InfoView,
    }
  ],
});

// Global navigation guard
router.beforeEach(async (to, from, next) => {
  // Retrieve the user object
  const user = JSON.parse(localStorage.getItem('user')) || null;

  // If the user is not logged in, redirect to the login page, except if already on the SignPage
  if (!user && to.name !== 'SignPage') {
    return next({ name: 'SignPage' });
  }

  // If user is logged in but doesn't have access, redirect to InfoView
  // except if they're already on InfoView or SignPage
  if (user && user.access === false && to.name !== 'InfoView' && to.name !== 'SignPage') {
    return next({ name: 'InfoView' });
  }

  // Prevent GENERAL users from accessing restricted routes
  if (user && user.role === 'GENERAL') {
    const restrictedRoutes = [
      NAVBAR_OPTIONS.APPROVAL_VIEW.name,
      NAVBAR_OPTIONS.FINANCE_VIEW.name,
      NAVBAR_OPTIONS.USER_VIEW.name
    ];
    
    if (restrictedRoutes.includes(to.name)) {
      return next({ name: NAVBAR_OPTIONS.REQUEST_VIEW.name });
    }
  }

  // Allow access to other pages if the user has access
  next();
});

export default router;
